import {carouselConstants} from "../../_constants/User";
import axiosInstance from "../../_helpers/axiosInstance";
import config from "../../Config/config";

// get carousel content from backend
export const get_carousel_content_action = () => async (dispatch) => {
    dispatch({
        type: carouselConstants.GET_CAROUSEL_CONTENT_ACTION_REQUEST
    })
    try {
        const response = await axiosInstance.get(config.users.getCarouselContents)
        if (response.status) {
            dispatch ({
                type: carouselConstants.GET_CAROUSEL_CONTENT_ACTION_SUCCESS,
                payload: response.data
            })
            return response.data
        } else {
            return false
        }
    } catch (e) {
        dispatch({
            type: carouselConstants.GET_CAROUSEL_CONTENT_ACTION_FAILURE,
            payload: e.msg
        })
    }
}